import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { stepShipmentSenderSsnAdded } from '../../../../../../actions/registerShipmentActions';
import { validateSsn } from '../../../../../../helpers/formHelpers/formHelpers';
import { Input } from '../../../../../base/forms/input';
import { IStepInfoFormInfo } from '../../../stepInfo/stepInfo.schema';

interface Props {
	setFieldValue: any;
	selected: boolean;
}

const RecipientPaysSocialIdPrompt: FC<Props> = ({ setFieldValue, selected }) => {
	const dispatch = useDispatch<any>();
	const { t } = useTranslation('registerShipment');
	const { stepInfoFormInfo }: { stepInfoFormInfo: IStepInfoFormInfo } = useSelector(
		({ registerShipmentReducer }) => registerShipmentReducer
	);
	const [ssnValid, setSsnValid] = useState(stepInfoFormInfo.senderSsn.length === 10);
	const [showInputBox, setShowInputBox] = useState(false);
	const [error, setError] = useState(false);

	const [socialId, setSocialId] = useState('');

	const onChange = e => {
		setSocialId(e.target.value);
	};
	useEffect(() => {
		const ssnValidation = async () => {
			if (socialId.length === 10) {
				const valid = await validateSsn(socialId);
				if (valid) {
					setError(false);
					setSsnValid(true);
					setFieldValue('senderSsnValid', true);
					dispatch(stepShipmentSenderSsnAdded(socialId));
				} else {
					setError(true);
					setSsnValid(false);
					setFieldValue('senderSsnValid', false);
				}
			} else if (socialId.length !== 0) {
				setError(true);
				setSsnValid(false);
				setFieldValue('senderSsnValid', false);
			}
		};
		ssnValidation();
	}, [dispatch, setSocialId, socialId, setError, setSsnValid, setFieldValue]);

	useEffect(() => {
		if (ssnValid) {
			setFieldValue('senderSsnValid', true);
		} else if (selected && !showInputBox) {
			setFieldValue('senderSsnValid', false);
			setShowInputBox(true);
			setError(true);
		} else if (!selected && showInputBox) {
			setShowInputBox(false);
			setFieldValue('senderSsnValid', true);
			setError(false);
		}
	}, [ssnValid, setSsnValid, stepInfoFormInfo, showInputBox, setShowInputBox, selected, setError, setFieldValue]);

	if (!showInputBox) {
		return null;
	}

	return (
		<>
			<Input
				type="text"
				value={socialId}
				onChange={onChange}
				placeholder={`${t('step-info.senderSsn')}`}
				maxlength="10"
			/>
			{error && <p>{t('step-info.ssn-valid')}</p>}
		</>
	);
};

export default RecipientPaysSocialIdPrompt;
